import React, { useState, useEffect, useCallback } from "react";
import {
  IconArrowRight,
  IconUserPlus,
  IconNote,
  IconCheck,
  IconPhone,
  IconCalendar,
  IconMessage,
} from "@tabler/icons-react";
import { getTimeline } from "../services/contacts.service";

const ICON_MAP = {
  stage_change: { icon: IconArrowRight, className: "crm-timeline__icon--stage" },
  owner_change: { icon: IconUserPlus, className: "crm-timeline__icon--owner" },
  note: { icon: IconNote, className: "crm-timeline__icon--note" },
  activity: { icon: IconCalendar, className: "crm-timeline__icon--activity" },
  activity_completed: { icon: IconCheck, className: "crm-timeline__icon--activity" },
  tag_added: { icon: IconNote, className: "" },
  tag_removed: { icon: IconNote, className: "" },
  session: { icon: IconMessage, className: "" },
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

const getItemDescription = (item) => {
  if (item.item_type === "event") return item.description;
  if (item.item_type === "note") return item.content;
  if (item.item_type === "activity") return `${item.title} (${item.activity_type}) - ${item.status}`;
  if (item.item_type === "session") return `Sessão de atendimento - ${item.status}`;
  return item.description || "";
};

const getItemAuthor = (item) => {
  if (item.created_by__first_name) return `${item.created_by__first_name} ${item.created_by__last_name || ""}`.trim();
  if (item.attendant__first_name) return item.attendant__first_name;
  if (item.assigned_to__first_name) return item.assigned_to__first_name;
  return "";
};

const Timeline = ({ contactId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  const fetchItems = useCallback(async (p = 1) => {
    try {
      setLoading(true);
      const resp = await getTimeline(contactId, p);
      if (p === 1) {
        setItems(resp.results || []);
      } else {
        setItems((prev) => [...prev, ...(resp.results || [])]);
      }
      setHasMore(resp.has_next || false);
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  }, [contactId]);

  useEffect(() => {
    fetchItems(1);
  }, [fetchItems]);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchItems(nextPage);
  };

  if (loading && items.length === 0) {
    return <div className="crm-empty"><span>Carregando timeline...</span></div>;
  }

  if (items.length === 0) {
    return <div className="crm-empty"><span className="crm-empty__desc">Nenhum evento registrado.</span></div>;
  }

  return (
    <div className="crm-timeline">
      {items.map((item, idx) => {
        const eventType = item.event_type || item.item_type;
        const config = ICON_MAP[eventType] || ICON_MAP.note;
        const Icon = config.icon;

        return (
          <div key={`${item.item_type}-${item.id}-${idx}`} className="crm-timeline__item">
            <div className={`crm-timeline__icon ${config.className}`}>
              <Icon size={14} />
            </div>
            <div className="crm-timeline__line" />
            <div className="crm-timeline__date">{formatDate(item.created_at || item.scheduled_at)}</div>
            <div className="crm-timeline__desc">{getItemDescription(item)}</div>
            {getItemAuthor(item) && (
              <div className="crm-timeline__author">{getItemAuthor(item)}</div>
            )}
          </div>
        );
      })}

      {hasMore && (
        <button className="crm-btn crm-btn--sm" onClick={handleLoadMore} style={{ marginTop: 12, marginLeft: 0 }}>
          Carregar mais
        </button>
      )}
    </div>
  );
};

export default Timeline;
